import { CustomTableComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { PredefinedComment } from '../predefined-comments.model';
import { useDefaultConfigPredefinedCommentsList } from './hooks/use-default-config-predefined-comments-list.hook';
import { usePredefinedCommentsList } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-predefined-comments-list.hook';
import { usePreserveSelectedHeaderCheckProps } from 'commons/components/table/hooks';
import { PredefinedCommentsActiveRowOptionsComponent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/components/predefined-comments-row-options/predefined-comments-active-row-options.component';
import { PredefinedCommentsInactiveRowOptionsComponent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/components/predefined-comments-row-options/predefined-comments-inactive-row-options.component';
import { usePredefinedCommentNavigation } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-predefined-comment-navigation.hook';
import { SettingsTableHeaderOptionsComponent } from 'modules/settings/components/settings-table-header-options/settings-table-header-options.component';

export const SettingsDevicesPredefinedCommentsListContainer: React.FC = () => {
    const { t } = useTranslation();
    const {
        comments,
        isTableLoading,
        showOnlyActive,
        handleShowOnlyActiveChange,
        selectedRows,
        setSelectedRows,
        handleOnSelectRow,
    } = usePredefinedCommentsList();
    const { navigateToEdit } = usePredefinedCommentNavigation();
    const { getDefaultConfig } = useDefaultConfigPredefinedCommentsList();

    const getRowOptions = (pdc: PredefinedComment) =>
        pdc.active
            ? PredefinedCommentsActiveRowOptionsComponent({ predefinedComment: pdc })
            : PredefinedCommentsInactiveRowOptionsComponent({ predefinedComment: pdc });

    const { selectedRowIds, headerCheckboxProps } = usePreserveSelectedHeaderCheckProps({
        selectedRows,
        data: comments,
        setSelectedRows,
    });

    return (
        <CustomTableComponent<PredefinedComment>
            headerTitle={t('settings.devices.predefined-comments.title')}
            loading={isTableLoading}
            totalElements={comments.length}
            tableData={comments}
            selectedRows={selectedRows}
            onSelectRow={(id, event) => handleOnSelectRow(id, event.detail)}
            onClickRow={(id) => navigateToEdit(id)}
            config={getDefaultConfig()}
            selectedRowIds={selectedRowIds}
            headerCheckboxProps={headerCheckboxProps}
            horizontalScroll
            emptyMessage={t('settings.devices.predefined-comments.no_comments_available')}
            rowOptions={getRowOptions}
            optionComponents={
                <SettingsTableHeaderOptionsComponent
                    onShowOnlyActiveChange={handleShowOnlyActiveChange}
                    showOnlyActive={showOnlyActive}
                    text={t('settings.devices.predefined-comments.show-inactive')}
                />
            }
        />
    );
};
